import { errMessageStyle } from './styles';

export const ErrMessage = ({ text, styles }) => {
    const classes = errMessageStyle();

    return (
        <span style={{ ...styles }} className={classes.errMessageStyleText}>
            {text}
        </span>
    );
};
